import { render, staticRenderFns } from "./ActionRequiredPanel.vue?vue&type=template&id=61589b0a&scoped=true"
import script from "./ActionRequiredPanel.vue?vue&type=script&lang=js"
export * from "./ActionRequiredPanel.vue?vue&type=script&lang=js"
import style0 from "./ActionRequiredPanel.vue?vue&type=style&index=0&id=61589b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61589b0a",
  null
  
)

export default component.exports